import React from "react";
import "./Plans.css";
import "../programs/Programs.css";
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";

const Plans = () => {
  return (
    <div className="plans-container" id="plans">
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>
      <div className="Programs-header">
        <span className="stroke-text">PRÊT À COMMENCER</span>
        <span>l'entraînement</span>
        <span className="stroke-text">MAINTENANT AVEC NOUS</span>
      </div>
      {/*plans card*/}
      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>{plan.price} DT</span>

            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img src={whiteTick} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>
            <button className="btn">Rejoignez</button>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Plans;
